import { render, staticRenderFns } from "./SearchResponsesItemStudy.vue?vue&type=template&id=01ef074c&scoped=true"
import script from "./SearchResponsesItemStudy.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItemStudy.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItemStudy.vue?vue&type=style&index=0&id=01ef074c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef074c",
  null
  
)

export default component.exports